import HeroSection from "../../Components/HeroSection";
import HowItWorksSection from "../../Components/HowItWorksSection";
import BookTrialClassForm from "../../Components/BookTrialClassForm";
import WhatMakesShyftBootCampUniqueSection from "../../Components/WhatMakesShyftBootCampUniqueSection";
import CallbackSection from "../../Components/CallbackSection";
import Testimonials from "@/components/Organisms/TestimonialsV2";
import RealWorldTransformation from "../../Components/RealWorldTransformation";
import AppBannerSection from "../../Components/AppBannerSection";
import BootcampListing from "../../Components/BootcampListing";
import AllPackagesSection from "../../Components/AllPackagesSection";
import ReadyToBuildSection from "../../Components/ReadyToBuildSection";
import FaqSection from "@/components/Molecules/FaqSection";
import FloatingBanner from "../../Components/FloatingBanner";
import BookSlotModal from "../../Components/BookSlotModal";
import BookTrialClassModal from "../../Components/BookTrialClassModal";
import CustomIntercomButton from "../../Components/CustomIntercomButton";
import SymptomsAndConditionsSection from "../../Components/SymptomsAndConditionsSection";

import CertifiedInstructors from "../../Components/Shared/CertifiedInstructors";

import { classNameGenerator } from "@/utils";

import { useAppSelector } from "@/hooks";

import styles from "./GeneralYogaPage.module.scss";

interface GeneralYogaPageProps {}

const GeneralYogaPage: React.FC<GeneralYogaPageProps> = () => {
  const cls = classNameGenerator(styles);

  const { data } = useAppSelector((state) => state.bootCamp);

  const { testimonies } = data?.testimonials || {};
  const faqs = data?.faqs || {};

  return (
    <div className={cls("generalYogaPage")}>
      <HeroSection />
      <HowItWorksSection>
        <BookTrialClassForm />
      </HowItWorksSection>
      <SymptomsAndConditionsSection />
      <WhatMakesShyftBootCampUniqueSection />
      <Testimonials testimonies={testimonies} />
      <CallbackSection />
      <RealWorldTransformation />
      <AllPackagesSection />
      <div className={cls("certifiedInstructors")}>
        <CertifiedInstructors />
      </div>
      <AppBannerSection />
      <BootcampListing />
      <FaqSection {...faqs} />
      <ReadyToBuildSection />
      <FloatingBanner />
      <BookSlotModal title={data?.bookSlotForm?.title} />
      <BookTrialClassModal />
      {/* <CustomIntercomButton /> */}
    </div>
  );
};

export default GeneralYogaPage;
